<template>
    <div class="ag-overlay-loading-center">
        {{ props.params.noRowsMessageFunc() }}
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

const props = defineProps({
    params: {
        type: Object,
        required: true
    }
});
</script>
